// Campus photo for /colleges/adelphi-university: CC BY-SA 4.0, by Shaunpassaic, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAdelphi_University_Quad.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/adelphi-university/; credited under the photo.
const photo = {
    "slug": "adelphi-university",
    "alt": "The quad at Adelphi University in Garden City, New York, with the Science Building and Blodgett Hall behind the lawns",
    "src": "/colleges/adelphi-university/campus-1600.webp",
    "srcSmall": "/colleges/adelphi-university/campus-800.webp",
    "srcMid": "/colleges/adelphi-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/adelphi-university/og.jpg",
    "title": "Adelphi University Quad",
    "author": "Shaunpassaic",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAdelphi_University_Quad.jpg",
    "read": "2026-10-01"
};

export default photo;
